import { useContext, useEffect } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import * as H from 'history'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Alert, Button, ButtonGroup, ToggleButton } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { A4, Landscape } from 'components/shared/print'
import { RequestForm, RequestFormSearchForm } from 'entities/request_form'
import { RequestFormPrintForm, useFetchRequestFormsApi } from 'api/request_form'
import './preview.scss'
import { useDownloadYamatoForHomeTestApi, usePrintRequestFormIssuanceApi } from 'api/request_form_issuance'
import { setPageSize } from 'utils/util'
import QRCode from 'qrcode.react'
import _ from 'lodash'
import { ModalButton } from 'components/shared/widget'
import { CheckboxField, DateField, SelectField } from 'components/shared/input'
import { YamatoDownloadForm } from 'api/task'
import { useFetchHomeProductsApi } from 'api/home_product'
import { HomeProductSearchForm } from 'entities/home_product'

type Props = {
    history: H.History
}

const PreviewRequestForm = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const { id } = useParams<{ id: string }>()
    const params = useQuery<RequestFormSearchForm & { institutionName: string; institutionCode: string; shippingCode: string }>()
    const searchForm = useForm<RequestFormSearchForm>({ ...params, perPage: 10000 })
    const api = useFetchRequestFormsApi(searchForm)
    const printForm = useForm<RequestFormPrintForm>({ ids: params.id }) // このidは配列
    const printApi = usePrintRequestFormIssuanceApi()
    const downloadForm = useForm<YamatoDownloadForm>({ fastest: true })
    const downloadApi = useDownloadYamatoForHomeTestApi()
    const homeProductSearchForm = useForm<HomeProductSearchForm>({ institutionId: params.institutionId })
    const homeProductsApi = useFetchHomeProductsApi(homeProductSearchForm)
    const productSelectForm = useForm<{ homeProductId: number | null }>({ homeProductId: null })

    // const handleAfterPrint = (event: Event) => {
    //     globalState.showConfirm(
    //         <>
    //             印刷完了しましたか？
    //             <br />
    //             OKを押すと印刷済みステータスへ移行します
    //         </>,
    //         () => {
    //             printApi.execute(Number(id), printForm)
    //         },
    //         {
    //             backdropStatic: true,
    //         }
    //     )
    // }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    useEffect(() => {
        setPageSize('portrait')
        api.execute()
        homeProductsApi.execute()
    }, [])

    useEffect(() => {
        downloadForm.updateObject('homeProductId', productSelectForm.object.homeProductId)
    }, [productSelectForm.object.homeProductId])

    const getHomeProduct = () => {
        const hp = homeProductsApi.response.results.find((hp) => hp.id === productSelectForm.object?.homeProductId)
        return hp
    }

    return (
        <div className="preview-request-form">
            <div className="no-print" style={{ padding: 20, marginTop: 10 }}>
                <ButtonGroup>
                    {homeProductsApi.response.results
                        .filter((hp) => _.uniq(api.response.results.map((rf) => rf.customerOrder?.homeProductId)).includes(hp.id))
                        .map((hp) => {
                            return (
                                <ToggleButton
                                    key={'product-select' + hp.id}
                                    type="radio"
                                    variant={'outline-primary'}
                                    name="radio"
                                    value={String(hp.id)}
                                    checked={productSelectForm.object.homeProductId === hp.id}
                                    onChange={(e) => productSelectForm.updateObject('homeProductId', Number(e.currentTarget.value))}
                                    onClick={() => {
                                        productSelectForm.updateObject('homeProductId', hp.id)
                                    }}
                                >
                                    {hp.name}
                                </ToggleButton>
                            )
                        })}
                </ButtonGroup>
            </div>
            {productSelectForm.object.homeProductId && (
                <>
                    <Flex className="no-print" alignItems="center">
                        <div style={{ padding: 15 }}>
                            <Button
                                style={{ width: 200 }}
                                onClick={() => {
                                    window.print()
                                }}
                            >
                                印刷プレビュー
                            </Button>
                        </div>

                        <ModalButton
                            openButton={<Button>ヤマトインポートシートDL</Button>}
                            modalHeader={<>ヤマトインポートシートダウンロード</>}
                            modalBody={
                                <div>
                                    {/* <SelectField
                                        form={downloadForm}
                                        attr="location"
                                        selectItems={masterData.userGroups.map((ug) => {
                                            return { label: ug.name, value: ug.name! }
                                        })}
                                        label="発送元"
                                        required
                                        includeBlank
                                    /> */}
                                    <Flex>
                                        <SelectField
                                            form={downloadForm}
                                            attr="kind"
                                            label="送り状種類"
                                            selectItems={[
                                                { value: '0', label: '発払い' },
                                                { value: '2', label: 'コレクト' },
                                                { value: '3', label: 'DM便' },
                                                { value: '4', label: 'タイム' },
                                                { value: '5', label: '着払い' },
                                                { value: '7', label: 'ネコポス' },
                                                { value: '8', label: '宅急便コンパクト' },
                                                { value: '9', label: '宅急便コンパクトコレクト' },
                                            ]}
                                            includeBlank
                                        />
                                        <DateField form={downloadForm} attr="postDate" label="出荷予定日" />
                                    </Flex>
                                    <Flex>
                                        <Flex style={{ width: '50%', height: 90 }} alignItems="center">
                                            <CheckboxField form={downloadForm} attr="fastest" checkboxLabel="最短日でお届けする" />
                                        </Flex>
                                        <div style={{ width: '50%' }}>
                                            <DateField form={downloadForm} attr="deliverDate" label="お届け予定日" disabled={downloadForm.object.fastest} />
                                        </div>
                                    </Flex>

                                    <SelectField
                                        form={downloadForm}
                                        attr="time"
                                        label="配達時間帯"
                                        selectItems={[
                                            { label: '午前中', value: '0812' },
                                            { label: '14~16時', value: '1416' },
                                            { label: '16~18時', value: '1618' },
                                            { label: '18~20時', value: '1820' },
                                            { label: '19~21時', value: '1921' },
                                            { label: '19~21時', value: '1921' },
                                            { label: '午前10時まで(DM便のみ)', value: '0010' },
                                            { label: '午後5時まで(DM便のみ)', value: '0017' },
                                        ]}
                                        includeBlank
                                        blankLabel="指定なし"
                                    />
                                </div>
                            }
                            submitButton={
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        downloadApi.execute(Number(params.requestFormIssuanceId), downloadForm)
                                    }}
                                >
                                    ダウンロード
                                </Button>
                            }
                        />
                    </Flex>
                    <>
                        <div className="no-print">
                            <Alert variant="info">バーコードシール用紙をプリンタにセットしてください</Alert>
                        </div>
                        {_.chunk([...api.response.results.filter((rf) => rf.customerOrder?.homeProductId === productSelectForm.object.homeProductId)], 30).map(
                            (pageRequestForms: RequestForm[], pageIndex: number) => {
                                return (
                                    <Landscape key={`page-${pageIndex}-${productSelectForm.object.homeProductId}`}>
                                        <A4 padding={0} landscape={false} style={{ position: 'relative', padding: '10.2mm 5mm' }}>
                                            <div>
                                                {(() => {
                                                    let count = 0
                                                    return _.chunk(pageRequestForms, 5).map((requestForms: RequestForm[], index: number) => {
                                                        return (
                                                            <Flex className="" key={'form-chunk-' + index}>
                                                                {new Array(5).fill(0).map((_, index) => {
                                                                    count += 1
                                                                    const requestForm = requestForms[index]
                                                                    return (
                                                                        <div
                                                                            style={{
                                                                                position: 'relative',
                                                                                flexGrow: 1,
                                                                                height: '46mm',
                                                                                display: 'flex',
                                                                                justifyContent: 'center',
                                                                            }}
                                                                            key={requestForm?.code}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    fontSize: 11,
                                                                                    width: '40mm',
                                                                                    height: '100%',
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                    padding: 5,
                                                                                }}
                                                                            >
                                                                                {requestForm && (
                                                                                    <div
                                                                                        style={{
                                                                                            transform: 'rotate(90deg)',
                                                                                            display: 'flex',
                                                                                            flexDirection: 'column',
                                                                                            justifyContent: 'space-between',
                                                                                            padding: 15,
                                                                                        }}
                                                                                    >
                                                                                        <Flex>
                                                                                            <div>
                                                                                                <div>採尿</div>
                                                                                                <div>時間</div>
                                                                                            </div>
                                                                                            <div>
                                                                                                <div>午前</div>
                                                                                                <div>午後</div>
                                                                                            </div>
                                                                                            <div style={{ marginLeft: 18 }}>時</div>
                                                                                            <div style={{ marginLeft: 22 }}>分</div>
                                                                                        </Flex>

                                                                                        <Flex justifyContent="space-between" style={{ height: '100px' }}>
                                                                                            <div style={{ fontWeight: 'bold', fontSize: 14 }}>氏名</div>
                                                                                            <div
                                                                                                style={{
                                                                                                    height: '100%',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                }}
                                                                                            >
                                                                                                <QRCode
                                                                                                    value={requestForm.code!}
                                                                                                    size={40}
                                                                                                    style={{
                                                                                                        padding: 2,
                                                                                                        transform: 'rotate(-90deg)',
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </Flex>

                                                                                        <Flex alignItems="center">
                                                                                            <div
                                                                                                style={{
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                    marginRight: 7,
                                                                                                }}
                                                                                            >
                                                                                                <div style={{ fontSize: 10, marginRight: 3 }}> ID: </div>
                                                                                                <div style={{ fontSize: 17, textDecoration: 'underline' }}>
                                                                                                    {requestForm?.code}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                style={{
                                                                                                    borderRadius: 10,
                                                                                                    width: 7,
                                                                                                    height: 7,
                                                                                                    backgroundColor: getHomeProduct()?.color
                                                                                                        ? getHomeProduct()?.color
                                                                                                        : 'inherit',
                                                                                                }}
                                                                                            ></div>
                                                                                        </Flex>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </Flex>
                                                        )
                                                    })
                                                })()}
                                            </div>
                                        </A4>
                                    </Landscape>
                                )
                            }
                        )}
                    </>
                </>
            )}
        </div>
    )
}

export default withRouter(PreviewRequestForm)
